import { isRecord } from 'fmrs';
import isStringTuple from '../is/is-string-tuple.js';
export default function isStringRecord(value) {
    if (!isRecord(value) || value instanceof Promise) {
        return false;
    }
    const entries = Object.entries(value);
    return entries.every(isStringTuple);
}
//# sourceMappingURL=is-string-record.js.map